import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "swiper-controls" }
const _hoisted_2 = { class: "swiper-navigation" }
const _hoisted_3 = ["disabled"]
const _hoisted_4 = { class: "sr-only" }
const _hoisted_5 = ["disabled"]
const _hoisted_6 = { class: "sr-only" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("button", {
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handlePrev && _ctx.handlePrev(...args))),
        class: "swiper-prev group",
        disabled: !_ctx.hasPrev
      }, [
        _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.t('prev')), 1),
        _cache[2] || (_cache[2] = _createElementVNode("svg", {
          class: "group-hover:shake-left",
          focusable: "false",
          "aria-hidden": "true",
          width: "20",
          height: "20"
        }, [
          _createElementVNode("use", { "xlink:href": "#arrow-left" })
        ], -1))
      ], 8, _hoisted_3),
      _createElementVNode("button", {
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleNext && _ctx.handleNext(...args))),
        class: "swiper-next group",
        disabled: !_ctx.hasNext
      }, [
        _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.t('next')), 1),
        _cache[3] || (_cache[3] = _createElementVNode("span", { style: {"display":"block","transform":"rotate(180deg)"} }, [
          _createElementVNode("svg", {
            class: "group-hover:shake-right",
            focusable: "false",
            "aria-hidden": "true",
            width: "20",
            height: "20"
          }, [
            _createElementVNode("use", { "xlink:href": "#arrow-left" })
          ])
        ], -1))
      ], 8, _hoisted_5)
    ])
  ]))
}